import React, { useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx";
import Application from "../../StateContext/Application";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { jwtDecode } from "jwt-decode";
import GooglePagination from "../../styles/GooglePagination";

const OldWorkOrderUpload = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserData(decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  const operation = useContext(Application);
  const { uploadworkorder, GetBudgetHeadInfo, GetProjectInfo, TypesOfWork } =
    operation;

  const [tableData, setTableData] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [HeadId, setHeadID] = useState([]);
  const [blocks, setBlocks] = useState([]); // == ulb options
  const [currentPage, setCurrentPage] = useState(1);
  const [contractorList, setContractorList] = useState([]);

  // const billsPerPage = 10;

  const [showAll, setShowAll] = useState(false);
  const billsPerPage = showAll ? filteredBills.length : 10;
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLast = currentPage * billsPerPage;
  const indexOfFirst = indexOfLast - billsPerPage;
  const currentBills = filteredBills.slice(indexOfFirst, indexOfLast);

  // ================= FETCH ULB / BLOCK LIST =================
  useEffect(() => {
    const fetchBlocks = async () => {
      let res = await GetBudgetHeadInfo("null", "GetTalukas");
      const unique = [...new Set(res.map((i) => i.ULBNameMarathi))];
      setBlocks(unique);
    };
    fetchBlocks();
  }, []);

  // ================= FETCH HEAD + CONTRACTOR LISTS =================
  useEffect(() => {
    const fetchInitial = async () => {
      const headRes = await GetBudgetHeadInfo("null", "all");
      setHeadID(headRes || []);

      const contractorRes = await GetProjectInfo("null", "Contractor");
      setContractorList(contractorRes || []);
    };

    fetchInitial();
  }, []);

  const formatExcelDate = (value) => {
    if (!value) return null;

    if (typeof value === "string") return value;

    if (typeof value === "number") {
      const date = XLSX.SSF.parse_date_code(value);
      if (!date) return value;

      return `${date.y}-${String(date.m).padStart(2, "0")}-${String(date.d).padStart(2, "0")}`;
    }

    return value;
  };

  // ✅ ONLY the columns WorkOrderCreation actually uses for
  // WorkOrderType === "Existing Work Order"
  const expectedColumns = [
    "HeadCode", // renamed from FundingHead - dropdown of head names
    "ProposalYear",
    "ulb",
    "WorkName", // renamed from ProposalId
    "ContractorName",
    "PanNo",
    "workClass", // dependent dropdown, filtered by HeadCode
    "WorkOrderNo",
    "WorkOrderDate",
    "WorkEndDate",
    "workApprovedGRDate",
    "ApprovedWorkAmount",
    "WorkCost",
  ];

  // ✅ FILE UPLOAD
  const handleFileUpload = (e) => {
    setLoading(true);
    const file = e.target.files[0];

    if (!file) {
      alert("Select file");
      setLoading(false);
      return;
    }

    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(ws, { defval: null });

        if (!json.length) {
          alert("Empty file");
          setLoading(false);
          return;
        }

        const fileCols = Object.keys(json[0]);
        const missing = expectedColumns.filter((c) => !fileCols.includes(c));

        if (missing.length > 0) {
          alert("Please Upload Correct Formatted Excel File Only");
          setLoading(false);
          return;
        }

        const formatted = json
          .map((row) => ({
            ...row,
            WorkOrderDate: formatExcelDate(row.WorkOrderDate),
            WorkEndDate: formatExcelDate(row.WorkEndDate),
            workApprovedGRDate: formatExcelDate(row.workApprovedGRDate),
          }))
          .filter((row) => {
            return (
              row.WorkName ||
              row.WorkOrderNo ||
              row.ContractorName ||
              row.HeadCode
            );
          })
          .map((row) => {
            // Strip "(AccountNumber)" suffix from ContractorName for clean display/storage
            const raw = String(row.ContractorName || "").trim();
            const match = raw.match(/^(.*)\s\(([^)]+)\)$/);
            const cleanName = match ? match[1].trim() : raw;

            return {
              ...row,
              ContractorName: cleanName,
              ContractorUniqueID: String(row.ContractorUniqueID || "").trim(),
            };
          });

        const invalidWorkNames = formatted.filter(
          (row) =>
            row.WorkName &&
            !/^[\u0900-\u097F0-9\s().,\/-]+$/.test(String(row.WorkName).trim()),
        );

        if (invalidWorkNames.length > 0) {
          alert(`Please enter Work Name in Marathi only`);
          setLoading(false);
          return;
        }

        // ✅ Amount columns must be numeric only (no characters/strings)
        const amountColumns = ["ApprovedWorkAmount", "WorkCost"];
        const isValidAmount = (val) => {
          if (val === null || val === undefined || val === "") return false;
          // Allows digits and an optional decimal point only — rejects letters, symbols, spaces mixed with text
          return /^\d+(\.\d+)?$/.test(String(val).trim());
        };

        const invalidAmountRows = formatted.filter((row) =>
          amountColumns.some((col) => !isValidAmount(row[col])),
        );

        if (invalidAmountRows.length > 0) {
          const badRows = invalidAmountRows
            .map((r) => r.WorkName || r.WorkOrderNo || "Unnamed row")
            .join("\n");

          alert(
            `Amount fields (ApprovedWorkAmount, WorkCost) must contain numbers only.\n\nCheck these rows:\n${badRows}`,
          );
          setLoading(false);
          return;
        }
           const invalidGRDates = formatted.filter((row) => {
        if (!row.workApprovedGRDate || !row.WorkOrderDate) {
          return false;
        }

        const grDate = new Date(row.workApprovedGRDate);
        const workOrderDate = new Date(row.WorkOrderDate);

        return grDate >= workOrderDate;
      });

      if (invalidGRDates.length > 0) {
        alert(
          "Work Approved GR Date should be before Work Order Date."
        );
        setLoading(false);
        return;
      }
        setTableData(formatted);
        setFilteredBills(formatted);
        setLoading(false);
      } catch (err) {
        console.error(err);
        alert("Invalid Excel");
        setLoading(false);
      }
    };

    reader.readAsBinaryString(file);
  };

  // ✅ SUBMIT
  const handleSubmit = async () => {
    if (!tableData.length) {
      return alert("No data");
    }

    // Contractor UniqueIDs from database
    const contractorIDs = contractorList.map((c) => String(c.UniqueID).trim());

    // Find rows with missing/invalid ContractorUniqueID
    const invalidRows = tableData.filter(
      (row) =>
        !row.ContractorUniqueID ||
        !contractorIDs.includes(String(row.ContractorUniqueID).trim()),
    );

    if (invalidRows.length > 0) {
      const names = [...new Set(invalidRows.map((r) => r.ContractorName))];

      alert(
        `Invalid Contractor Selection for:\n\n${names.join("\n")}\n\nPlease reselect the Contractor Name from the dropdown in the Excel file.`,
      );

      return;
    }

    try {
      setLoading(true);

      const payload = tableData.map((row) => ({
        ...row,
        WorkOrderType: "Existing Work Order",
      }));

      const res = await uploadworkorder(payload);

      if (res?.status) {
        alert(res?.message || "Uploaded Successfully");

        setTableData([]);
        setFilteredBills([]);
        setCurrentPage(1);

        window.location.reload();
      } else {
        alert(res?.message || "Upload failed");
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      alert("Upload failed");
      setLoading(false);
    }
  };

  const downloadSampleExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();

      const worksheet = workbook.addWorksheet("WorkOrder");
      const dropdownSheet = workbook.addWorksheet("DropdownData");
      dropdownSheet.state = "hidden";

      // ================= DROPDOWN VALUES =================
      const headNameOptions = HeadId.map((h) => h.HeadName);
      const proposalYears = Array.from({ length: 7 }, (_, i) => {
        const start = 2019 + i;
        return `${start}-${start + 1}`;
      });
      const ulbOptions = blocks;
      const contractorOptions = contractorList.map(
        (item) => item.Bidder_CompanyName,
      );

      // ================= FETCH CLASS-OF-WORK OPTIONS PER HEAD =================
      // workClass depends on HeadCode (same relationship CreateWorkOrder.js
      // uses via TypesOfWork(HeadCode)), so build a flat (HeadName, WorkType)
      // lookup table to drive a dependent dropdown.
      const classOfWorkRows = []; // [{ headName, workType }]
      for (const head of HeadId) {
        try {
          const types = await TypesOfWork(head.HeadID?.trim());
          const uniqueTypes = [
            ...new Set((types || []).map((t) => t.Work_Type)),
          ].filter(Boolean);

          uniqueTypes.forEach((wt) => {
            classOfWorkRows.push({ headName: head.HeadName, workType: wt });
          });
        } catch (err) {
          console.error("TypesOfWork fetch failed for", head.HeadName, err);
        }
      }

      // ================= WRITE DROPDOWN DATA =================
      // A: HeadCode dropdown source (head names)
      headNameOptions.forEach((v, i) => {
        dropdownSheet.getCell(`A${i + 1}`).value = v;
      });

      // C: Proposal years
      proposalYears.forEach((v, i) => {
        dropdownSheet.getCell(`C${i + 1}`).value = v;
      });

      // D: ULB / block options
      ulbOptions.forEach((v, i) => {
        dropdownSheet.getCell(`D${i + 1}`).value = v;
      });

      // P: Contractor names, Q: Contractor PAN (for PanNo auto-fill)
      contractorList.forEach((item, i) => {
        const row = i + 1;
        const label = `${item.Bidder_CompanyName || ""} (${item.Account_Number || ""})`;
        dropdownSheet.getCell(`P${row}`).value = label; // ✅ fixed
        dropdownSheet.getCell(`Q${row}`).value = item.PAN_No || "";
        dropdownSheet.getCell(`U${row}`).value = item.UniqueID || "";
      });

      // R: HeadName, S: WorkType (helper table for workClass dependent dropdown)
      classOfWorkRows.forEach((row, i) => {
        dropdownSheet.getCell(`R${i + 1}`).value = row.headName;
        dropdownSheet.getCell(`S${i + 1}`).value = row.workType;
      });

      // ================= COLUMNS =================
      const columns = expectedColumns.map((col) => ({
        header: col,
        key: col,
        width: 22,
      }));

      // Extra auto-filled column (not user-required) — populated via formula below
      columns.push({
        header: "ContractorUniqueID",
        key: "ContractorUniqueID",
        width: 22,
      });

      worksheet.columns = columns;
      worksheet.getColumn("L").numFmt = "@";
      worksheet.getColumn("M").numFmt = "@";

      // ================= SAMPLE ROW =================
      worksheet.addRow({
        HeadCode: HeadId?.[0]?.HeadName || "",
        ProposalYear: proposalYears[0],
        ulb: ulbOptions[0] || "",
        WorkName: "कामांची नावे",
        ContractorName: contractorList?.[0]
          ? `${contractorList[0].Bidder_CompanyName} (${contractorList[0].Account_Number})`
          : "",
        PanNo: "",
        workClass:
          classOfWorkRows.find((r) => r.headName === HeadId?.[0]?.HeadName)
            ?.workType || "",
        WorkOrderNo: "WO-001",
        WorkOrderDate: "01-04-2026",
        WorkEndDate: "31-12-2026",
        workApprovedGRDate: "31-03-2026",
        ApprovedWorkAmount: "100000",
        WorkCost: "1000",
      });

      worksheet.getColumn("L").eachCell({ includeEmpty: true }, (cell) => {
        cell.numFmt = "@";
      });
 
      worksheet.getColumn("M").eachCell({ includeEmpty: true }, (cell) => {
        cell.numFmt = "@";
      });

      // ================= APPLY DROPDOWNS / FORMULAS =================
      // Column order: A HeadCode, B ProposalYear, C ulb, D WorkName,
      // E ContractorName, F PanNo, G workClass, H WorkOrderNo,
      // I WorkOrderDate, J WorkEndDate, K ApprovedWorkAmount, L PaidAmount
      for (let i = 2; i <= 500; i++) {
        // HeadCode dropdown (list of head names)
        worksheet.getCell(`A${i}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`DropdownData!$A$1:$A$${headNameOptions.length}`],
        };

        // ProposalYear dropdown
        worksheet.getCell(`B${i}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`DropdownData!$C$1:$C$${proposalYears.length}`],
        };

        // ulb dropdown
        worksheet.getCell(`C${i}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`DropdownData!$D$1:$D$${ulbOptions.length}`],
        };

        // ContractorName dropdown
        worksheet.getCell(`E${i}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`DropdownData!$P$1:$P$${contractorOptions.length}`],
        };

        // PanNo auto-derived from ContractorName
        worksheet.getCell(`F${i}`).value = {
          formula: `IFERROR(INDEX(DropdownData!$Q:$Q,MATCH(E${i},DropdownData!$P:$P,0)),"")`,
        };

        // workClass dependent dropdown, filtered by this row's HeadCode (A)
        worksheet.getCell(`G${i}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [
            `OFFSET(DropdownData!$S$1,
                MATCH(A${i},DropdownData!$R$1:$R$5000,0)-1,
                0,
                COUNTIF(DropdownData!$R$1:$R$5000,A${i}),
                1
              )`,
          ],
        };

        // ContractorUniqueID auto-derived from the same label (NEW — column N)
        worksheet.getCell(`N${i}`).value = {
          formula: `IFERROR(INDEX(DropdownData!$U:$U,MATCH(E${i},DropdownData!$P:$P,0)),"")`,
        };
      }

      // ================= STYLING =================
      worksheet.getRow(1).font = { color: { argb: "FFFFFF" }, bold: true };
      worksheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "2C78DB" },
      };

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), "Existing_WorkOrder_Sample.xlsx");
    } catch (error) {
      console.error(error);
      alert("Failed to generate sample file");
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#EFF3F8",
        height: "90vh",
        overflowX: "hidden",
        overflowY: "scroll",
        position: "relative",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <h4 style={{ marginBottom: "15px" }}>
          Upload Existing Work Orders Excel
        </h4>

        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.6)",
              backdropFilter: "blur(4px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                border: "6px solid #eee",
                borderTop: "6px solid #007bff",
                borderRadius: "50%",
                width: "60px",
                height: "60px",
                animation: "spin 1s linear infinite",
              }}
            />
          </div>
        )}

        <div style={{ marginBottom: "10px" }}>
          <span
            onClick={downloadSampleExcel}
            style={{ color: "#007bff", cursor: "pointer", fontWeight: "500" }}
          >
            Download Sample Excel
          </span>
        </div>

        <div style={{ marginBottom: "15px" }}>
          <input
            type="file"
            accept=".xls,.xlsx"
            onChange={handleFileUpload}
            className="form-control"
          />
        </div>

        {tableData.length > 0 && (
          <>
            <div
              style={{
                marginTop: "10px",
                borderRadius: "6px",
                overflow: "hidden",
                border: "1px solid #ccc",
              }}
            >
              <div
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  overflowX: "auto",
                }}
              >
                <table
                  style={{
                    minWidth: "1400px",
                    borderCollapse: "collapse",
                    width: "100%",
                  }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#2C78DB",
                      color: "white",
                      zIndex: 2,
                    }}
                  >
                    <tr>
                      {Object.keys(tableData[0]).map((col, i) => (
                        <th
                          key={i}
                          style={{
                            padding: "10px",
                            minWidth: "160px",
                            borderRight: "1px solid #ddd",
                            fontSize: "12px",
                          }}
                        >
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {currentBills.map((row, i) => (
                      <tr
                        key={i}
                        style={{
                          background: i % 2 === 0 ? "#F8FBFF" : "#EAF4FB",
                        }}
                      >
                        {Object.values(row).map((val, j) => (
                          <td
                            key={j}
                            style={{
                              padding: "8px",
                              fontSize: "12px",
                              borderRight: "1px solid #eee",
                              borderBottom: "1px solid #eee",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {val?.toString()}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                marginTop: "15px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: "13px", color: "#555" }}>
                Showing {indexOfFirst + 1} to{" "}
                {Math.min(indexOfLast, filteredBills.length)} of{" "}
                {filteredBills.length} entries
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <GooglePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />

                <button
                  onClick={() => {
                    setShowAll(!showAll);
                    setCurrentPage(1);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#fff",
                    background: showAll
                      ? "linear-gradient(135deg, #28a745, #20c997)"
                      : "linear-gradient(135deg, #0067ab, #0098d5)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {showAll ? "✓ Showing All" : "View All"}
                </button>
              </div>
              {/* <div style={{ display: "flex", gap: "5px" }}>
                <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                  {"<<"}
                </button>
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  {"<"}
                </button>

                <span
                  style={{
                    padding: "5px 10px",
                    background: "#2C78DB",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  {currentPage}
                </span>

                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  {">"}
                </button>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  {">>"}
                </button>
              </div> */}
            </div>

            <div style={{ textAlign: "right", marginTop: "20px" }}>
              <button
                onClick={handleSubmit}
                style={{
                  background:
                    "linear-gradient(to right, #3b409e, #0067ab, #0098d5)",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>

      <style>
        {`@keyframes spin {0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`}
      </style>
    </div>
  );
};

export default OldWorkOrderUpload;

//--> old code
// import React, { useContext, useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import Application from "../../StateContext/Application";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { jwtDecode } from "jwt-decode";
// import GooglePagination from "../../styles/GooglePagination";

// const OldWorkOrderUpload = () => {
//   const [userData, setUserData] = useState(null);

//   useEffect(() => {
//     const token = localStorage.getItem("Token");
//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         setUserData(decoded);
//       } catch (error) {
//         console.error("Invalid token:", error);
//       }
//     }
//   }, []);

//   const operation = useContext(Application);
//   const { uploadworkorder, GetBudgetHeadInfo, GetProjectInfo, TypesOfWork } =
//     operation;

//   const [tableData, setTableData] = useState([]);
//   const [filteredBills, setFilteredBills] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [HeadId, setHeadID] = useState([]);
//   const [blocks, setBlocks] = useState([]); // == ulb options
//   const [currentPage, setCurrentPage] = useState(1);
//   const [contractorList, setContractorList] = useState([]);

//   const [showAll, setShowAll] = useState(false);
//    const billsPerPage = showAll ? filteredBills.length : 10;
//   const totalPages = Math.ceil(filteredBills.length / billsPerPage);
//   const indexOfLast = currentPage * billsPerPage;
//   const indexOfFirst = indexOfLast - billsPerPage;
//   const currentBills = filteredBills.slice(indexOfFirst, indexOfLast);

//   // ================= FETCH ULB / BLOCK LIST =================
//   useEffect(() => {
//     const fetchBlocks = async () => {
//       let res = await GetBudgetHeadInfo("null", "GetTalukas");
//       const unique = [...new Set(res.map((i) => i.ULBNameMarathi))];
//       setBlocks(unique);
//     };
//     fetchBlocks();
//   }, []);

//   // ================= FETCH HEAD + CONTRACTOR LISTS =================
//   useEffect(() => {
//     const fetchInitial = async () => {
//       const headRes = await GetBudgetHeadInfo("null", "all");
//       setHeadID(headRes || []);

//       const contractorRes = await GetProjectInfo("null", "Contractor");
//       setContractorList(contractorRes || []);
//     };

//     fetchInitial();
//   }, []);

//   const formatExcelDate = (value) => {
//     if (!value) return null;

//     if (typeof value === "string") return value;

//     if (typeof value === "number") {
//       const date = XLSX.SSF.parse_date_code(value);
//       if (!date) return value;

//       return `${date.y}-${String(date.m).padStart(2, "0")}-${String(date.d).padStart(2, "0")}`;
//     }

//     return value;
//   };

//   // ✅ ONLY the columns WorkOrderCreation actually uses for
//   // WorkOrderType === "Existing Work Order"
//   const expectedColumns = [
//     "HeadCode", // renamed from FundingHead - dropdown of head names
//     "ProposalYear",
//     "ulb",
//     "WorkName", // renamed from ProposalId
//     "ContractorName",
//     "PanNo",
//     "workClass", // dependent dropdown, filtered by HeadCode
//     "WorkOrderNo",
//     "WorkOrderDate",
//     "WorkEndDate",
//     "workApprovedGRDate",
//     "ApprovedWorkAmount",
//     "WorkCost"
//   ];

//   // ✅ FILE UPLOAD
//   const handleFileUpload = (e) => {
//     setLoading(true);
//     const file = e.target.files[0];

//     if (!file) {
//       alert("Select file");
//       setLoading(false);
//       return;
//     }

//     const reader = new FileReader();

//     reader.onload = (evt) => {
//       try {
//         const wb = XLSX.read(evt.target.result, { type: "binary" });
//         const ws = wb.Sheets[wb.SheetNames[0]];
//         const json = XLSX.utils.sheet_to_json(ws, { defval: null });

//         if (!json.length) {
//           alert("Empty file");
//           setLoading(false);
//           return;
//         }

//         const fileCols = Object.keys(json[0]);
//         const missing = expectedColumns.filter((c) => !fileCols.includes(c));

//         if (missing.length > 0) {
//           alert("Please Upload Correct Formatted Excel File Only");
//           setLoading(false);
//           return;
//         }

//         const formatted = json
//           .map((row) => ({
//             ...row,
//             WorkOrderDate: formatExcelDate(row.WorkOrderDate),
//             WorkEndDate: formatExcelDate(row.WorkEndDate),
//             workApprovedGRDate: formatExcelDate(row.workApprovedGRDate),
//           }))
//           .filter((row) => {
//             return (
//               row.WorkName ||
//               row.WorkOrderNo ||
//               row.ContractorName ||
//               row.HeadCode
//             );
//           });

//           const invalidWorkNames = formatted.filter(
//             (row) =>
//               row.WorkName &&
//               !/^[\u0900-\u097F0-9\s().,\/-]+$/.test(String(row.WorkName).trim())
//           );

//           if (invalidWorkNames.length > 0) {
//             alert(
//               `Please enter Work Name in Marathi only`
//             );
//             setLoading(false);
//             return;
//           }

//         setTableData(formatted);
//         setFilteredBills(formatted);
//         setLoading(false);
//       } catch (err) {
//         console.error(err);
//         alert("Invalid Excel");
//         setLoading(false);
//       }
//     };

//     reader.readAsBinaryString(file);
//   };

//   // ✅ SUBMIT
//   const handleSubmit = async () => {
//     if (!tableData.length) {
//       return alert("No data");
//     }

//     // Contractor names from database
//   const contractorNames = contractorList.map(c =>
//     c.Bidder_CompanyName.trim().toLowerCase()
//   );

//   // Find invalid contractors
//   const invalidRows = tableData.filter(row =>
//     !contractorNames.includes(
//       (row.ContractorName || "").trim().toLowerCase()
//     )
//   );

//   if (invalidRows.length > 0) {
//     const names = [...new Set(invalidRows.map(r => r.ContractorName))];

//     alert(
//       `Invalid Contractor Name(s):\n\n${names.join("\n")}\n\nPlease correct the Excel file.`
//     );

//     return;
//   }

//     try {
//       setLoading(true);

//       const payload = tableData.map((row) => ({
//         ...row,
//         WorkOrderType: "Existing Work Order",
//       }));

//       const res = await uploadworkorder(payload);

//       if (res?.status) {
//         alert(res?.message || "Uploaded Successfully");

//         setTableData([]);
//         setFilteredBills([]);
//         setCurrentPage(1);

//         window.location.reload();
//       } else {
//         alert(res?.message || "Upload failed");
//       }

//       setLoading(false);
//     } catch (err) {
//       console.error(err);
//       alert("Upload failed");
//       setLoading(false);
//     }
//   };

//   const downloadSampleExcel = async () => {
//     try {
//       const workbook = new ExcelJS.Workbook();

//       const worksheet = workbook.addWorksheet("WorkOrder");
//       const dropdownSheet = workbook.addWorksheet("DropdownData");
//       dropdownSheet.state = "hidden";

//       // ================= DROPDOWN VALUES =================
//       const headNameOptions = HeadId.map((h) => h.HeadName);
//       const proposalYears = Array.from({ length: 7 }, (_, i) => {
//         const start = 2019 + i;
//         return `${start}-${start + 1}`;
//       });
//       const ulbOptions = blocks;
//       const contractorOptions = contractorList.map(
//         (item) => item.Bidder_CompanyName,
//       );

//       // ================= FETCH CLASS-OF-WORK OPTIONS PER HEAD =================
//       // workClass depends on HeadCode (same relationship CreateWorkOrder.js
//       // uses via TypesOfWork(HeadCode)), so build a flat (HeadName, WorkType)
//       // lookup table to drive a dependent dropdown.
//       const classOfWorkRows = []; // [{ headName, workType }]
//       for (const head of HeadId) {
//         try {
//           const types = await TypesOfWork(head.HeadID?.trim());
//           const uniqueTypes = [
//             ...new Set((types || []).map((t) => t.Work_Type)),
//           ].filter(Boolean);

//           uniqueTypes.forEach((wt) => {
//             classOfWorkRows.push({ headName: head.HeadName, workType: wt });
//           });
//         } catch (err) {
//           console.error("TypesOfWork fetch failed for", head.HeadName, err);
//         }
//       }

//       // ================= WRITE DROPDOWN DATA =================
//       // A: HeadCode dropdown source (head names)
//       headNameOptions.forEach((v, i) => {
//         dropdownSheet.getCell(`A${i + 1}`).value = v;
//       });

//       // C: Proposal years
//       proposalYears.forEach((v, i) => {
//         dropdownSheet.getCell(`C${i + 1}`).value = v;
//       });

//       // D: ULB / block options
//       ulbOptions.forEach((v, i) => {
//         dropdownSheet.getCell(`D${i + 1}`).value = v;
//       });

//       // P: Contractor names, Q: Contractor PAN (for PanNo auto-fill)
//       contractorList.forEach((item, i) => {
//         const row = i + 1;
//         dropdownSheet.getCell(`P${row}`).value = item.Bidder_CompanyName || "";
//         dropdownSheet.getCell(`Q${row}`).value = item.PAN_No || "";
//       });

//       // R: HeadName, S: WorkType (helper table for workClass dependent dropdown)
//       classOfWorkRows.forEach((row, i) => {
//         dropdownSheet.getCell(`R${i + 1}`).value = row.headName;
//         dropdownSheet.getCell(`S${i + 1}`).value = row.workType;
//       });

//       // ================= COLUMNS =================
//       const columns = expectedColumns.map((col) => ({
//         header: col,
//         key: col,
//         width: 22,
//       }));

//       worksheet.columns = columns;

//       // ================= SAMPLE ROW =================
//       worksheet.addRow({
//         HeadCode: HeadId?.[0]?.HeadName || "",
//         ProposalYear: proposalYears[0],
//         ulb: ulbOptions[0] || "",
//         WorkName: "कामांची नावे",
//         ContractorName: contractorList?.[0]?.Bidder_CompanyName || "",
//         PanNo: "",
//         workClass: classOfWorkRows.find(
//           (r) => r.headName === HeadId?.[0]?.HeadName,
//         )?.workType || "",
//         WorkOrderNo: "WO-001",
//         WorkOrderDate: "2026-04-01",
//         WorkEndDate: "2026-12-31",
//         workApprovedGRDate: "2026-12-31",
//         ApprovedWorkAmount: "100000",
//         WorkCost:"1000"
//       });

//       // ================= APPLY DROPDOWNS / FORMULAS =================
//       // Column order: A HeadCode, B ProposalYear, C ulb, D WorkName,
//       // E ContractorName, F PanNo, G workClass, H WorkOrderNo,
//       // I WorkOrderDate, J WorkEndDate, K ApprovedWorkAmount, L PaidAmount
//       for (let i = 2; i <= 500; i++) {
//         // HeadCode dropdown (list of head names)
//         worksheet.getCell(`A${i}`).dataValidation = {
//           type: "list",
//           allowBlank: true,
//           formulae: [`DropdownData!$A$1:$A$${headNameOptions.length}`],
//         };

//         // ProposalYear dropdown
//         worksheet.getCell(`B${i}`).dataValidation = {
//           type: "list",
//           allowBlank: true,
//           formulae: [`DropdownData!$C$1:$C$${proposalYears.length}`],
//         };

//         // ulb dropdown
//         worksheet.getCell(`C${i}`).dataValidation = {
//           type: "list",
//           allowBlank: true,
//           formulae: [`DropdownData!$D$1:$D$${ulbOptions.length}`],
//         };

//         // ContractorName dropdown
//         worksheet.getCell(`E${i}`).dataValidation = {
//           type: "list",
//           allowBlank: true,
//           formulae: [`DropdownData!$P$1:$P$${contractorOptions.length}`],
//         };

//         // PanNo auto-derived from ContractorName
//         worksheet.getCell(`F${i}`).value = {
//           formula: `IFERROR(INDEX(DropdownData!$Q:$Q,MATCH(E${i},DropdownData!$P:$P,0)),"")`,
//         };

//         // workClass dependent dropdown, filtered by this row's HeadCode (A)
//         worksheet.getCell(`G${i}`).dataValidation = {
//           type: "list",
//           allowBlank: true,
//           formulae: [
//             `OFFSET(DropdownData!$S$1,
//                 MATCH(A${i},DropdownData!$R$1:$R$5000,0)-1,
//                 0,
//                 COUNTIF(DropdownData!$R$1:$R$5000,A${i}),
//                 1
//               )`,
//           ],
//         };
//       }

//       // ================= STYLING =================
//       worksheet.getRow(1).font = { color: { argb: "FFFFFF" }, bold: true };
//       worksheet.getRow(1).fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "2C78DB" },
//       };

//       const buffer = await workbook.xlsx.writeBuffer();
//       saveAs(new Blob([buffer]), "Existing_WorkOrder_Sample.xlsx");
//     } catch (error) {
//       console.error(error);
//       alert("Failed to generate sample file");
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: "20px",
//         backgroundColor: "#EFF3F8",
//         height: "90vh",
//         overflowX: "hidden",
//         overflowY: "scroll",
//         position: "relative",
//       }}
//     >
//       <div
//         style={{
//           background: "white",
//           padding: "20px",
//           borderRadius: "8px",
//           boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//         }}
//       >
//         <h4 style={{ marginBottom: "15px" }}>
//           Upload Existing Work Orders Excel
//         </h4>

//         {loading && (
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               background: "rgba(255,255,255,0.6)",
//               backdropFilter: "blur(4px)",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 9999,
//             }}
//           >
//             <div
//               style={{
//                 border: "6px solid #eee",
//                 borderTop: "6px solid #007bff",
//                 borderRadius: "50%",
//                 width: "60px",
//                 height: "60px",
//                 animation: "spin 1s linear infinite",
//               }}
//             />
//           </div>
//         )}

//         <div style={{ marginBottom: "10px" }}>
//           <span
//             onClick={downloadSampleExcel}
//             style={{ color: "#007bff", cursor: "pointer", fontWeight: "500" }}
//           >
//             Download Sample Excel
//           </span>
//         </div>

//         <div style={{ marginBottom: "15px" }}>
//           <input
//             type="file"
//             accept=".xls,.xlsx"
//             onChange={handleFileUpload}
//             className="form-control"
//           />
//         </div>

//         {tableData.length > 0 && (
//           <>
//             <div
//               style={{
//                 marginTop: "10px",
//                 borderRadius: "6px",
//                 overflow: "hidden",
//                 border: "1px solid #ccc",
//               }}
//             >
//               <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>
//                 <table style={{ minWidth: "1400px", borderCollapse: "collapse", width: "100%" }}>
//                   <thead
//                     style={{
//                       position: "sticky",
//                       top: 0,
//                       background: "#2C78DB",
//                       color: "white",
//                       zIndex: 2,
//                     }}
//                   >
//                     <tr>
//                       {Object.keys(tableData[0]).map((col, i) => (
//                         <th
//                           key={i}
//                           style={{
//                             padding: "10px",
//                             minWidth: "160px",
//                             borderRight: "1px solid #ddd",
//                             fontSize: "12px",
//                           }}
//                         >
//                           {col}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentBills.map((row, i) => (
//                       <tr key={i} style={{ background: i % 2 === 0 ? "#F8FBFF" : "#EAF4FB" }}>
//                         {Object.values(row).map((val, j) => (
//                           <td
//                             key={j}
//                             style={{
//                               padding: "8px",
//                               fontSize: "12px",
//                               borderRight: "1px solid #eee",
//                               borderBottom: "1px solid #eee",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {val?.toString()}
//                           </td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             <div
//               style={{
//                 marginTop: "15px",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//               }}
//             >
//               <div style={{ fontSize: "13px", color: "#555" }}>
//                 Showing {indexOfFirst + 1} to {Math.min(indexOfLast, filteredBills.length)} of{" "}
//                 {filteredBills.length} entries
//               </div>

//               <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "10px",
//                       }}
//                     >
//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={setCurrentPage}
//                       />

//                       <button
//                         onClick={() => {
//                           setShowAll(!showAll);
//                           setCurrentPage(1);
//                         }}
//                         style={{
//                           border: "none",
//                           outline: "none",
//                           cursor: "pointer",
//                           padding: "8px 16px",
//                           borderRadius: "20px",
//                           fontSize: "13px",
//                           fontWeight: "600",
//                           color: "#fff",
//                           background: showAll
//                             ? "linear-gradient(135deg, #28a745, #20c997)"
//                             : "linear-gradient(135deg, #0067ab, #0098d5)",
//                           boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                           transition: "all 0.3s ease",
//                         }}
//                       >
//                         {showAll ? "✓ Showing All" : "View All"}
//                       </button>
//                     </div>
//               {/* <div style={{ display: "flex", gap: "5px" }}>
//                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
//                   {"<<"}
//                 </button>
//                 <button
//                   onClick={() => setCurrentPage(currentPage - 1)}
//                   disabled={currentPage === 1}
//                 >
//                   {"<"}
//                 </button>

//                 <span
//                   style={{
//                     padding: "5px 10px",
//                     background: "#2C78DB",
//                     color: "white",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   {currentPage}
//                 </span>

//                 <button
//                   onClick={() => setCurrentPage(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                 >
//                   {">"}
//                 </button>
//                 <button
//                   onClick={() => setCurrentPage(totalPages)}
//                   disabled={currentPage === totalPages}
//                 >
//                   {">>"}
//                 </button>
//               </div> */}
//             </div>

//             <div style={{ textAlign: "right", marginTop: "20px" }}>
//               <button
//                 onClick={handleSubmit}
//                 style={{
//                   background: "linear-gradient(to right, #3b409e, #0067ab, #0098d5)",
//                   color: "white",
//                   padding: "10px 20px",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Submit
//               </button>
//             </div>
//           </>
//         )}
//       </div>

//       <style>
//         {`@keyframes spin {0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`}
//       </style>
//     </div>
//   );
// };

// export default OldWorkOrderUpload;
